import React from "react";

import IconVideo from "./IconVideo";
import IconQuiz from "./IconQuiz";
import IconValid from "./IconValid";
import IconInvalid from "./IconInvalid";
import IconReplay from "./IconReplay";
import IconCancel from "./IconCancel";
import IconHome from "./IconHome";
import IconChevron from "./IconChevron";
import IconLink from "./IconLink";
import IconTimer from "./IconTimer";
import IconGlasses from "./IconGlasses";

interface Props extends React.SVGProps<SVGSVGElement> {
  name:
    | "quiz"
    | "video"
    | "valid"
    | "invalid"
    | "replay"
    | "cancel"
    | "home"
    | "chevron"
    | "link"
    | "timer"
    | "glasses";
}
const Icon: React.FC<Props> = (props) => {
  switch (props.name) {
    case "quiz":
      return <IconQuiz {...props} />;
    case "video":
      return <IconVideo {...props} />;
    case "valid":
      return <IconValid {...props} />;
    case "invalid":
      return <IconInvalid {...props} />;
    case "replay":
      return <IconReplay {...props} />;
    case "cancel":
      return <IconCancel {...props} />;
    case "home":
      return <IconHome {...props} />;
    case "chevron":
      return <IconChevron {...props} />;
    case "link":
      return <IconLink {...props} />;
    case "timer":
      return <IconTimer {...props} />;
    case "glasses":
      return <IconGlasses {...props} />;
  }
};

export default Icon;
